export default __webpack_public_path__ + "static/media/2.15.c58340cc.mp3";